import { Spin, message, notification } from "antd";
import requestService from "api/request";
import clsx from "clsx";
import {
  formatTime,
  validateEmail,
  validatePassword,
} from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "store";

export function getJSONFromUrl() {
  try {
    let search = window.location.search.substring(1);
    let json = JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}',
    );
    let result = {} as any;
    Object.keys(json).forEach((key: any) => {
      result[decodeURIComponent(key)] = decodeURIComponent(json[key]);
    });
    return result;
  } catch (e) {
    return {};
  }
}

const Register = () => {
  const { appGlobal } = useAppSelector((state) => state.app) as any;
  let { r } = getJSONFromUrl();
  const [showPass, setShowPass] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [form, setForm] = useState<any>();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [isResendOtp, setIsResendOtp] = useState(false);
  const navigate = useNavigate();

  function isValidUsername(userName: string) {
    // Kiểm tra nếu userName chỉ chứa chữ cái thường và số, không dấu và không có khoảng trắng
    const regex = /^[a-z0-9]+$/;
    return regex.test(userName);
  }

  const handleRegister = async () => {
    // if (!isValidUsername(form?.user_name))
    //   return notification.error({
    //     message: "Tên người dùng chữ thường viết liền không dấu",
    //     duration: 5,
    //   });
    if (!isCheck)
      return notification.error({
        message: "Please agree User Agreement and and Privacy Policy!",
        duration: 5,
      });
    if (!validateEmail(form?.email)) {
      return notification.error({
        message: "Invalid email format",
        duration: 5,
      });
    }
    if (!validatePassword(form?.password)) {
      return notification.error({
        message: "Password must be at least 6 characters",
        duration: 5,
      });
    }
    setLoading(true);
    try {
      const res = await requestService.post("/auth/register", {
        data: {
          ...form,
        },
      });
      if (res && res.data) {
        notification.success({
          message: "Register success",
          duration: 3,
        });
        navigate("/login");
      }
    } catch (error: any) {
      console.log(error);

      notification.error({
        message: error?.response?.data?.message || "Có lỗi xảy ra thử lại !!!",
        duration: 3,
      });
    }
    setLoading(false);
  };

  const resendOtp = async (e: any) => {
    e.preventDefault();

    try {
      const res = await requestService.post("/auth/send-otp", {
        data: {
          email: form?.email,
        },
      });
      if (res && res?.data) {
        setIsResendOtp(true);
        localStorage.setItem("date", JSON.stringify(new Date().getTime()));
      }
    } catch (error: any) {
      console.log(error);
      notification.error({
        message: error?.response?.data?.message,
        duration: 3,
      });
    }
  };

  function isLowercaseNoDiacritics(str: string) {
    // Remove diacritics and convert to lowercase
    const processedStr = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    // Check if the string contains only lowercase letters without spaces or special characters
    return /^[a-z]+$/.test(processedStr);
  }

  useEffect(() => {
    setForm({
      ...form,
      ref_code: r,
    });
  }, [r]);
  return (
    <div className="min-h-[100vh] bg-v3BgPrimary" data-v-bc61f9fc="">
      <Spin spinning={loading} fullscreen />
      <div className="main-box lay-box clearfix " data-v-bc61f9fc="">
        <div
          className="main-login-wrapper black flex items-center justify-center"
          data-v-6fa5d2d2=""
          data-v-bc61f9fc=""
        >
          <div className="main-login" data-v-6fa5d2d2="">
            <div
              className="container main-box-container main-box-container-login"
              data-v-62803376=""
              data-v-6fa5d2d2=""
            >
              <div className="login-wrap black mainReg" data-v-62803376="">
                <div className="login-qr-box" data-v-62803376="">
                  {/**/}
                  <div className="clearfix login-title-box" data-v-62803376="">
                    <h1
                      className="login-qr-title flex justify-center mb-24px"
                      data-v-62803376=""
                    >
                      {t("Chào mừng bạn đã trở lại Sising")}
                    </h1>
                    {/**/}
                  </div>
                  {/**/}
                  <div className="mt-24px" data-v-62803376="">
                    <div className="login-qr-form black" data-v-62803376="">
                      {/* /// Nhập Email hoặc SĐT */}
                      <div
                        className="login-form-group !mb-3"
                        data-v-62803376=""
                      >
                        <label data-v-62803376="">Email</label>
                        <div
                          data-v-4c55cf80=""
                          data-v-62803376=""
                          className="main-login-phone-mail flex items-center gap-2"
                        >
                          <div
                            data-v-4c55cf80=""
                            className="phon-email-wrap flex-1"
                          >
                            <input
                              data-v-4c55cf80=""
                              type="text"
                              autoComplete="off"
                              name="dnPhone"
                              value={form?.email}
                              onChange={(e) =>
                                setForm({ ...form, email: e?.target?.value })
                              }
                              placeholder={t("Nhập Email")}
                              data-testid="LoginAccountInput"
                              className="input custom-login-input custom-login-input-vi "
                            />
                          </div>
                          {/* {isResendOtp ? (
                            <button
                              disabled
                              className="h-[40px] !p-3 !text-[10px] flex justify-center items-center bit-button  bit-button--chunky bit-button--medium is-round"
                            >
                              <Countdown
                                date={
                                  parseInt(
                                    localStorage.getItem("date") || "0"
                                  ) +
                                  1000 * 60 * 5
                                }
                                renderer={({ minutes, seconds }) =>
                                  formatTime(minutes, seconds)
                                }
                                onComplete={() => {
                                  setIsResendOtp(true);
                                  localStorage.removeItem("date");
                                }}
                              />
                            </button>
                          ) : (
                            <button
                              onClick={resendOtp}
                              className="h-[40px] !p-3 !text-[10px] flex justify-center items-center bit-button  bit-button--chunky bit-button--medium is-round"
                            >
                              Send OTP
                            </button>
                          )} */}
                        </div>
                        <label
                          htmlFor="dnEmail"
                          className="for-border !mb-0"
                          data-v-62803376=""
                        />
                      </div>

                      {/* /// Nhập User Name */}
                      <div
                        className="login-form-group relative !mb-3"
                        data-v-62803376=""
                      >
                        <div data-v-0d5d0f59="" data-v-44ccf62d="">
                          <div data-v-0d5d0f59="" className="reg-form-input">
                            <label data-v-0d5d0f59="">
                              {t("Tên đăng nhập")}
                            </label>{" "}
                            <input
                              data-v-0d5d0f59=""
                              name="dnPwd"
                              maxLength={32}
                              value={form?.user_name}
                              onChange={(e) =>
                                setForm({
                                  ...form,
                                  user_name: e?.target?.value,
                                })
                              }
                              placeholder={t("Nhập tên người dùng")}
                              data-testid="RegisterPasswordInput"
                              type="text"
                              className="input custom-login-input custom-login-input-vi"
                            />
                          </div>{" "}
                          {/**/} {/**/}{" "}
                        </div>
                      </div>

                      {/* /// Nhập Password */}
                      <div
                        className="login-form-group relative !mb-3"
                        data-v-62803376=""
                      >
                        <div data-v-0d5d0f59="" data-v-44ccf62d="">
                          <div data-v-0d5d0f59="" className="reg-form-input">
                            <label data-v-0d5d0f59="">{t("Mật khẩu")}</label>{" "}
                            <input
                              data-v-0d5d0f59=""
                              autoComplete="new-password"
                              name="dnPwd"
                              maxLength={32}
                              value={form?.password}
                              onChange={(e) =>
                                setForm({ ...form, password: e?.target?.value })
                              }
                              placeholder={t("Nhập Mật Khẩu")}
                              data-testid="RegisterPasswordInput"
                              type={showPass ? "text" : "password"}
                              className="input custom-login-input custom-login-input-vi"
                            />
                          </div>{" "}
                          {/**/} {/**/}{" "}
                          <div
                            data-v-0d5d0f59=""
                            className="show-pwd-str pwd-eye"
                            onClick={() => setShowPass(!showPass)}
                          >
                            {showPass ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="size-6"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="size-6"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                      </div>
                      {/**/}

                      {/* Họ và tên */}

                      <div
                        className="login-form-group relative !mb-3"
                        data-v-62803376=""
                      >
                        <div data-v-0d5d0f59="" data-v-44ccf62d="">
                          <div data-v-0d5d0f59="" className="reg-form-input">
                            <label data-v-0d5d0f59="">{t("Họ và tên")}</label>{" "}
                            <input
                              data-v-0d5d0f59=""
                              autoComplete="new-password"
                              name="dnPwd"
                              maxLength={32}
                              value={form?.last_name}
                              onChange={(e) =>
                                setForm({
                                  ...form,
                                  last_name: e?.target?.value,
                                })
                              }
                              placeholder={t("Nhập họ và tên")}
                              data-testid="RegisterPasswordInput"
                              type="text"
                              className="input custom-login-input custom-login-input-vi"
                            />
                          </div>{" "}
                        </div>
                      </div>
                      {/* /// Nhập OTP */}
                      {/* <div
                        className="login-form-group relative"
                        data-v-62803376=""
                      >
                        <div data-v-0d5d0f59="" data-v-44ccf62d="">
                          <div data-v-0d5d0f59="" className="reg-form-input">
                            <label data-v-0d5d0f59="">{t("OTP")}</label>{" "}
                            <input
                              data-v-0d5d0f59=""
                              autoComplete="new-password"
                              name="dnPwd"
                              maxLength={32}
                              value={form?.otp}
                              onChange={(e) =>
                                setForm({
                                  ...form,
                                  otp: e?.target?.value,
                                })
                              }
                              placeholder={t("Nhập OTP")}
                              data-testid="RegisterPasswordInput"
                              type="text"
                              className="input custom-login-input custom-login-input-vi"
                            />
                          </div>{" "}
                        </div>
                      </div> */}

                      {/* Họ và tên */}

                      <div
                        data-v-44ccf62d=""
                        className="reg-protocol clearfix flex flex-col items-start mt-5"
                      >
                        <div
                          data-v-44ccf62d=""
                          className="flex items-center gap-8px"
                        >
                          <label
                            data-v-44ccf62d=""
                            className="bit-checkbox user-protocol-check"
                          >
                            <span
                              className={clsx("bit-checkbox__input is-main ", {
                                "is-checked": isCheck,
                              })}
                            >
                              <span className="bit-checkbox__inner" />
                              <input
                                type="checkbox"
                                data-testid="RegisterUserProtocolAndPolicyCheckbox"
                                className="bit-checkbox__original"
                                onChange={(e) => {
                                  setIsCheck(e.target.checked);
                                }}
                              />
                            </span>
                            <span className="bit-checkbox__label">
                              <p
                                data-v-44ccf62d=""
                                className="user-protocol"
                                style={{
                                  wordBreak: "break-word",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {t("Tôi đã đọc và đồng ý với")}{" "}
                                <a
                                  href="/support/articles/360014944032-Terms-of-Users"
                                  target="_blank"
                                >
                                  {t("Thỏa thuận Người dùng và")}
                                </a>{" "}
                                <a
                                  href="/vi/support/articles/360015150651"
                                  target=" _blank"
                                >
                                  {t("Chính sách Quyền riêng tư")}
                                </a>
                              </p>
                              {/**/}
                            </span>
                          </label>
                        </div>{" "}
                        {/**/}
                      </div>

                      <div data-v-62803376=" " className="!mt-5">
                        <div className="iphone:mt-21px" data-v-62803376="">
                          <button
                            type="button"
                            className="bit-button w-full bit-button--chunky bit-button--medium is-round"
                            style={{ boxShadow: "0 4px 0 0 undefined" }}
                            data-v-62803376=""
                            onClick={handleRegister}
                          >
                            {/**/}
                            {/**/}
                            {/**/}
                            <span> {t("Đăng ký")}</span>
                            {/**/}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="go-reg" data-v-62803376="">
                    <span className="mr-2" data-v-62803376="">
                      {t("Bạn đã có tài khoản?")}
                    </span>
                    <Link to="/login" data-v-62803376="">
                      {t("Đăng nhập")}
                    </Link>
                  </div>
                </div>
                {/**/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
